import BigNumber from 'bignumber.js';
import { useStoreCurrencyMenu } from '~/stores/strapi/currencyMenu';

export const formatAmmount = (amountCents: number | BigNumber, currency: string): string => {
  const storeCurrencyMenu = useStoreCurrencyMenu();

  const paymentCurrency = storeCurrencyMenu.activeCurrencies.find(
    (c) => c.currencyCode.toUpperCase() === currency
  );

  const amount = new BigNumber(amountCents);
  const precision = paymentCurrency?.precision || 2;

  if (storeCurrencyMenu.cryptoCurrencyCodes.includes(currency) && currency !== 'USDT') {
    if (
      amount.shiftedBy(-precision).isLessThan(0.1) &&
      amount.shiftedBy(-precision).isGreaterThan(0.000001)
    ) {
      return formatAmmount(amount.shiftedBy(-3), `m${currency}`);
    } else if (amount.shiftedBy(-precision).isLessThanOrEqualTo(new BigNumber(0.000001))) {
      return formatAmmount(amount, `μ${currency}`);
    }
  }

  return `${amount.shiftedBy(-precision).toString()} ${currency}`;
};
